import { useStaticQuery, graphql } from 'gatsby';
import { useIntl } from 'react-intl';

interface IHubspotForm {
  node_locale: string;
  formKey: string;
  hubspotForm: string;
}

const useHubspotForm = (formKey: string) => {
  const { locale } = useIntl();
  const { hubspotForms } = useStaticQuery(graphql`
    query {
      hubspotForms: allContentfulHubspotForm {
        nodes {
          node_locale
          formKey
          hubspotForm
        }
      }
    }
  `);

  return hubspotForms
    .nodes
    .find((form: IHubspotForm) => form.formKey === formKey && form.node_locale === locale);
};

export default useHubspotForm;
